class MapApplication {
  constructor() {
    this.map = null
    this.testPoints = []
    this.isMobile = null
    this.ctlOpt = new esmap.ESControlOptions({
      position: esmap.ESControlPositon.LEFT_BOTTOM,
      imgURL: 'image/wedgets/',
      offset: {
        x: 50,
        y: 50,
      },
    })
    this.effectLayerWall = new esmap.ESEffectTool.EffectLayer('wall', esmap.ESLayer.EFFECT_MARKER)
    this.effectLayerLine = new esmap.ESEffectTool.EffectLayer('line', esmap.ESLayer.EFFECT_MARKER)
    this.floorControl = null
    this.floorLayer = null
    this.extentWall1 = null
    this.popMarker1 = null
    this.circleRippleMakerSign = null
    this.cylinderSpreadMakerSign = null
    this.pointsLine = null
    this.lineMarker = null
    this.pointsAry = [
      [
        { x: 12681921.402778065, y: 2575285.459293384, offset: 0 },
        { x: 12682028.385734057, y: 2574588.9235051177, offset: 800 },
        { x: 12682109.602751743, y: 2574070.986672658, offset: 0 },
      ],
      [
        { x: 12682109.602751743, y: 2574070.986672658, offset: 0 },
        { x: 12682538.016989235, y: 2574445.266097628, offset: 800 },
        { x: 12682676.019837826, y: 2574773.9027037993, offset: 0 },
      ],
      [
        { x: 12682676.019837826, y: 2574773.9027037993, offset: 0 },
        { x: 12683152.886919893, y: 2574382.82208666, offset: 800 },
        { x: 12683319.169410078, y: 2574123.8732628934, offset: 0 },
      ],
      [
        { x: 12683319.169410078, y: 2574123.8732628934, offset: 0 },
        { x: 12683676.724376217, y: 2574568.54563921, offset: 800 },
        { x: 12684017.549838895, y: 2574938.421418464, offset: 0 },
      ],
    ]
    this.isTileLoadedFirst = false
    this.mapParameterID = null
    this.isBuildingId = {}
  }
  /**
   * 初始化地图
   */
  initMap () {
    let self = this
    // this.map = new esmap.ESWorldMap({
    this.map = new esmap.ESMap({
      mode: esmap.MapMode.City,
      container: document.getElementById('map-container'),
      themeID: this.mapParameterID.themeid || 'W2001', //主题ID
      // cids: 'esmapcitydemo',
      tileType: 'autonavi', // 高德瓦片地图
      mapDataSrc: './data', // 地图数据位置
      token: 'escope',
      center: { "x": 12682971.48, "y": 2574724.08 },
      maximumTiles: 128,
      loadRoads: true,
    })
    this.map.openMapById('esmapcitydemo')  //新版本

    // 初始化场景特效
    esmap.ESEffectTool.init({
      onlineEffectThemeId: this.mapParameterID.effectid || 'E2004',
      // 1 2 3 4
      loadRoads: true, // 是否加载特效主题的路网特效
      isSetRoomEffect: true, // 是否设置瓦片建筑特效
      isShowSkybox: true, // 是否展示天空盒
      isSetModelEffect: false, // 是否设置模型特效
      isOpenScreenEffect: true, // 是否开启全屏特效
      effectQuality: this.isMobile || null
    })

    // 初始化地图瓦片
    esmap.ESTileMap.init({
      scaleLevel: 16, // 地图默认初始化缩放等级
      scaleLevelAnimate: false, // 地图初始化后层级变化动画, { targetLevel(目标缩放层级), duration(过渡时间) }
      openTileClick: true, // 是否开瓦片地图点击
      isShowWater: false, // 是否应用瓦片水域特效
    })
    this.map.showCompass = true
    this.map.showScaler = true

    this.map.on('loadComplete', function () {
      self.floorControl = new esmap.ESScrollFloorsControl(self.map, self.ctlOpt)
      self.floorLayer = self.map.getBuildingById(0).getFloor(1)
      self.addTextMarker()
    })

    // 室内建筑加载完成后
    this.map.on('buildingLoadComplete', function (building) {
      // 更新楼层控件
      self.floorControl.update(building)
      self.isBuildingId[building.id] = true
    })

    this.map.on('closeBuilding', function (e) {
      self.isBuildingId[e.bid] = false
      let flyBackFlag = true
      for (const key in self.isBuildingId) {
        const element = self.isBuildingId[key];
        if (element == true) {
          flyBackFlag = false  // 若有室内建筑被打开则不执行退出飞行视角
        }
      }

      if (flyBackFlag) self.flyBack()
    })

    // 特效包初始化完成
    this.map.on('effectsInitComplete', function (data) {
      // 特效标注相关的处理需要确保在特效初始化完成后执行
      esmap.ESEffectTool.addLayerToMap(self.effectLayerLine)
      self.addCircleRippleMaker()
      self.addCylinderSpreadMaker()
      self.addPointsLineMaker()
      self.addBesizerCurve()

    })

    // 当前视图内瓦片更新完成
    this.map.on('tileUpdated', function () {
      if (!self.isTileLoadedFirst) {
        self.isTileLoadedFirst = true;
        // 启动地图扫描光
        esmap.ESEffectTool.buildings.updateBuildingScanLight('radar_scan', {
          scanCenter: {
            x: 12682692.53, y: 2574733.68
          }, // 扫描中心
          scanColor: '#3bffc0', // 扫描光颜色
          scanRadius: 4000, // 扫描光半径
          scanSpeed: 1, // 扫描速度
        })
      }
    })

    // 地图点击事件
    this.map.on('mapClickNode', function (e) {
      console.log(e)
      self.manageImageClick(e)
    })
  }

  // 图标点击事件
  manageImageClick (e) {
    console.log(e)
    if (e.name === '腾讯滨海大厦') {
      this.map.cameraFlyTo({
        "directionAngle": 0.02, "pitchAngle": 48.23, "radius": 339.3, "x": 12682685.09, "y": 2574799.9, "z": 0, "time": 3,
        callback: function () { },
      })
    } else if (e.name === "易景空间商场") {
      this.map.cameraFlyTo({
        "directionAngle": 358.99, "pitchAngle": 41.52, "radius": 339.3, "x": e.mapCoord.x, "y": e.mapCoord.y, "z": 0, "time": 3,
        callback: function () { }
      })
    }
  }

  // 回到原点
  flyBack () {
    this.map.cameraFlyTo({
      "directionAngle": 1.47, "pitchAngle": 37.16, "radius": 3662.11, "x": 12682971.48, "y": 2574724.08, "z": 0,
      time: 2,
      callback: function () { },
    })
  }

  // 添加区域围墙
  addExtentWallMaker () {
    let extentList = [
      // 当前样式的围墙组
      {
        id: 'a',
        points: [
          { x: 12681901.013572564, y: 2574538.7276001484 },
          { x: 12682486.238720132, y: 2574393.8242202685 },
          { x: 12682540.885770502, y: 2574281.5394862825 },
          { x: 12682461.872337544, y: 2574005.945539009 },
          { x: 12682268.93947279, y: 2573493.5381797934 },
          { x: 12682041.862700343, y: 2573648.686792482 },
          { x: 12681772.688637828, y: 2573865.4757515583 },
        ],
      },
      {
        id: 'b',
        points: [
          { x: 12682541.371528363, y: 2574811.487198764 },
          { x: 12682574.362544594, y: 2574834.874123574 },
          { x: 12682708.218076475, y: 2574758.3506025174 },
          { x: 12683008.645354295, y: 2574711.838297901 },
          { x: 12683182.894583147, y: 2574683.082850816 },
          { x: 12683185.878697237, y: 2574644.749371733 },
          { x: 12683052.457182892, y: 2574364.153951533 },
          { x: 12682995.22717238, y: 2574335.3818860925 },
          { x: 12682609.177243503, y: 2574434.678313297 },
          { x: 12682577.861941405, y: 2574490.6011497104 },
          { x: 12682547.467882788, y: 2574659.2749893963 },
        ],
      },
      {
        id: 'c',
        points: [
          { x: 12683044.359800786, y: 2574253.208086534 },
          { x: 12683811.007086938, y: 2574214.7756801983 },
          { x: 12683860.612578046, y: 2574169.0406185994 },
          { x: 12683874.262349885, y: 2574085.5368253584 },
          { x: 12683751.755969161, y: 2573741.446661205 },
          { x: 12683659.83624469, y: 2573497.712748128 },
          { x: 12682953.74517438, y: 2573680.060540151 },
          { x: 12682924.967339585, y: 2573732.8197041354 },
        ],
      },
    ]
    if (this.extentWall1) {
      this.effectLayer.removeAll()
      this.extentWall1 = null
    } else {
      this.extentWall1 = new esmap.ESEffectTool.EffectMarker(esmap.ESMarkerType.EXTENT_WALL, {
        height: 25, // 离地板高度
        color: '#ff73fb',
        wallHeight: 25, // 围墙高度
        extentList: extentList, // 围墙点集
        isShine: true, // 是否发光（需要开启开启全屏特效）
        groundColor: '#ff73fb',
        // seeThrough: true // 是否穿透物体显示
      })
      this.effectLayer.addMarker(this.extentWall1)
    }
  }
  addCircleRippleMaker () {
    if (this.circleRippleMakerSign) {
      this.circleRippleMakerSign = null
      this.effectLayerLine.removeAll()
    } else {
      this.circleRippleMakerSign = 1
      let marker = new esmap.ESEffectTool.EffectMarker(esmap.ESMarkerType.CIRCLE_ROTATE, {
        x: 12682109.602751743,
        y: 2574070.986672658,
        radius: 100,
        height: 3,
        isShine: true,
        isSpread: true,
        color: '#19c2e4',
      })
      this.effectLayerLine.addMarker(marker)

      let marker_2 = new esmap.ESEffectTool.EffectMarker(esmap.ESMarkerType.CIRCLE_ROTATE, {
        x: 12682676.019837826,
        y: 2574773.9027037993,
        radius: 100,
        height: 3,
        isShine: true,
        isSpread: true,
        color: '#19c2e4',
      })
      this.effectLayerLine.addMarker(marker_2)

      let marker_3 = new esmap.ESEffectTool.EffectMarker(esmap.ESMarkerType.CIRCLE_ROTATE, {
        x: 12683319.169410078,
        y: 2574123.8732628934,
        radius: 100,
        height: 3,
        isShine: true,
        isSpread: true,
        color: '#19c2e4',
      })
      this.effectLayerLine.addMarker(marker_3)

      let marker_4 = new esmap.ESEffectTool.EffectMarker(esmap.ESMarkerType.CIRCLE_ROTATE, {
        x: 12684017.549838895,
        y: 2574938.421418464,
        radius: 100,
        height: 3,
        isShine: true,
        isSpread: true,
        color: '#19c2e4',
      })
      this.effectLayerLine.addMarker(marker_4)

      let marker_5 = new esmap.ESEffectTool.EffectMarker(esmap.ESMarkerType.CYLINDER_SPREAD, {
        x: 12681921.402778065,
        y: 2575285.459293384,
        radius: 100,
        height: 3,
        isShine: true,
        isSpread: true,
        color: '#19c2e4',
      })
      this.effectLayerLine.addMarker(marker_5)
    }
  }

  // 创建圆筒扩散标注
  addCylinderSpreadMaker () {
    if (this.cylinderSpreadMakerSign) {
      this.cylinderSpreadMakerSign = null
      this.effectLayerLine.removeAll()
    } else {
      this.cylinderSpreadMakerSign = 1
      let marker = new esmap.ESEffectTool.EffectMarker(esmap.ESMarkerType.CYLINDER_SPREAD, {
        x: 12682109.602751743,
        y: 2574070.986672658,
        height: 40, // 离地板高度
        radius: 150, // 半径
        scanHeight: 120, // 扫描高度
        isShine: true, // 是否发光（需要开启开启全屏特效）
      })
      this.effectLayerLine.addMarker(marker)

      let marker_2 = new esmap.ESEffectTool.EffectMarker(esmap.ESMarkerType.CYLINDER_SPREAD, {
        x: 12682676.019837826,
        y: 2574773.9027037993,
        height: 40, // 离地板高度
        radius: 150, // 半径
        scanHeight: 120, // 扫描高度
        isShine: true, // 是否发光（需要开启开启全屏特效）
      })
      this.effectLayerLine.addMarker(marker_2)

      let marker_3 = new esmap.ESEffectTool.EffectMarker(esmap.ESMarkerType.CYLINDER_SPREAD, {
        x: 12683319.169410078,
        y: 2574123.8732628934,

        height: 40,
        radius: 150,
        scanHeight: 120,
        isShine: true,
      })
      this.effectLayerLine.addMarker(marker_3)

      let marker_4 = new esmap.ESEffectTool.EffectMarker(esmap.ESMarkerType.CYLINDER_SPREAD, {
        x: 12684017.549838895,
        y: 2574938.421418464,

        height: 40,
        radius: 150,
        scanHeight: 120,
        isShine: true,
      })
      this.effectLayerLine.addMarker(marker_4)

      let marker_5 = new esmap.ESEffectTool.EffectMarker(esmap.ESMarkerType.CYLINDER_SPREAD, {
        x: 12681921.402778065,
        y: 2575285.459293384,
        height: 40,
        radius: 150,
        scanHeight: 120,
        isShine: true,
      })
      this.effectLayerLine.addMarker(marker_5)
    }
  }

  // 创建点云线标注
  addPointsLineMaker () {
    if (this.pointsLine) {
      this.pointsLine = null
      this.effectLayerLine.removeAll()
    } else {
      let coords = [
        { x: 12681921.402778065, y: 2575285.459293384, height: 7 },
        { x: 12682109.602751743, y: 2574070.986672658, height: 7 },
        { x: 12682676.019837826, y: 2574773.9027037993, height: 7 },
        { x: 12683319.169410078, y: 2574123.8732628934, height: 7 },
        { x: 12684017.549838895, y: 2574938.421418464, height: 7 },
      ]
      this.pointsLine = new esmap.ESEffectTool.EffectMarker(esmap.ESMarkerType.POINTS_LINE, {
        gapDistance: 20, // 点与点直接的间距
        color: '#33CCCC', // 颜色
        pointSize: 100, // 点的大小
        points: coords, // 点集
        isShine: true, // 是否发光（需要开启开启全屏特效）
        // seeThrough: true // 是否穿透物体显示
      })
      this.effectLayerLine.addMarker(this.pointsLine)
    }
  }
  // 添加贝塞尔曲线
  addBesizerCurve () {
    for (let points of this.pointsAry) this.drawTrackLine(points)
  }

  // 绘制轨迹线
  drawTrackLine (points) {
    let newPoints = esmap.ESMapUtil.buildBezierCurvePoints({
      points: points, // 3个点（起始点，控制点，结束点）
      segments: 20, // 曲线点集数
    })
    if (!this.lineMarker) {
      this.lineMarker = new esmap.ESEffectTool.EffectMarker(esmap.ESMarkerType.ROUTES_LINE, {
        color: '#33CCCC', // 颜色
        height: 10, // 离地板高度
        lineWidth: 10, // 线宽（缩放固定）
        isShine: true, // 是否发光（需要开启开启全屏特效）
      })
      this.effectLayerLine.addMarker(this.lineMarker)
    }
    this.lineMarker.addLine(newPoints) // 绘制线
  }

  // 创建文本标注
  addTextMarker () {
    let layer = new esmap.ESLayer('textMarker')

    layer.addMarker(
      new esmap.ESTextMarker({
        x: 12682109.602751743,
        y: 2574070.986672658,
        height: 80,
        name: '气象观测点',
        showLevel: 30,
        // spritify: false, //是否跟随地图缩放默认为true
        fillcolor: '51,153,255', //填充色
        fontsize: '14.0', //字体大小
        strokecolor: '255,255,255', //边框色
        seeThrough: true
      })
    )

    layer.addMarker(
      new esmap.ESTextMarker({
        x: 12682676.019837826,
        y: 2574773.9027037993,
        height: 80,
        name: '气象观测点',
        showLevel: 30,
        // spritify: false, //是否跟随地图缩放默认为true
        fillcolor: '51,153,255', //填充色
        fontsize: '14.0', //字体大小
        strokecolor: '255,255,255', //边框色
        seeThrough: true
      })
    )

    layer.addMarker(
      new esmap.ESTextMarker({
        x: 12683319.169410078,
        y: 2574123.8732628934,
        height: 80,
        name: '气象观测点',
        showLevel: 30,
        // spritify: false, //是否跟随地图缩放默认为true
        fillcolor: '51,153,255', //填充色
        fontsize: '14.0', //字体大小
        strokecolor: '255,255,255', //边框色
        seeThrough: true
      })
    )

    layer.addMarker(
      new esmap.ESTextMarker({
        x: 12684017.549838895,
        y: 2574938.421418464,
        height: 80,
        name: '气象观测点',
        showLevel: 30,
        // spritify: false, //是否跟随地图缩放默认为true
        fillcolor: '51,153,255', //填充色
        fontsize: '14.0', //字体大小
        strokecolor: '255,255,255', //边框色
        seeThrough: true
      })
    )

    layer.addMarker(
      new esmap.ESTextMarker({
        x: 12681921.402778065,
        y: 2575285.459293384,
        height: 80,
        name: '气象观测点',
        showLevel: 30,
        // spritify: false, //是否跟随地图缩放默认为true
        fillcolor: '51,153,255', //填充色
        fontsize: '14.0', //字体大小
        strokecolor: '255,255,255', //边框色
        seeThrough: true
      })
    )
    this.floorLayer.addLayer(layer)
  }

  // 清除所有
  clearAll () {
    if (this.effectLayer) this.effectLayer.removeAll()
    this.extentWall1 = null
  }
  judgeMapParam () {
    let tempID = this.getHashParameters()
    this.mapParameterID = { themeid: null, effectid: null, ...tempID }

    let sUserAgent = navigator.userAgent.toLowerCase()
    if (/ipad|iphone|midp|rv:1.2.3.4|ucweb|android|windows ce|windows mobile/.test(sUserAgent)) {
      this.isMobile = 'high'
    }
  }

  // 获取 hash 类型的 url 参数
  getHashParameters () {
    if (location.hash.split("?")[1]) {
      let arr = location.hash.split('?')[1].split('&')
      let params = {}
      for (let i = 0; i < arr.length; i++) {
        let data = arr[i].split('=')
        if (data.length === 2) {
          params[data[0]] = data[1]
        }
      }
      return params
    }
    else return null
  }

}

export default new MapApplication()
